module.exports = "<app-logo-header></app-logo-header>\r\n\r\n  <p>\r\n  home works!\r\n</p>\r\n"